import { useEffect, useState } from "react";

export const useGoogleAnalyticsHandler = (requestData) => {

    const [initialized, setInitialized] = useState(false)

    useEffect(() => {
        if (!window.jostensGASY25enabledPLP) return;

        const scriptId = 'google-analytics-script';

        // Return if the page is not initialized yet with proper parameters
        if((!requestData?.customerNumber) || (!requestData?.publishedCatalogId) || (!requestData?.sourceCatalogType) || (!requestData?.catalogOsr)) return;

        // Return if GA Script is already injected.
        if(document.querySelector(`#${scriptId}`)) return;

        const googleAnalyticsScriptElement = document.createElement('script');
        googleAnalyticsScriptElement.src = '/apps/jcom/s4/src/js-lib/jostens-ga-tracking/jostens-ga-tracking.js';
        googleAnalyticsScriptElement.setAttribute("data-ot-ignore", "data-ot-ignore");
        googleAnalyticsScriptElement.setAttribute("id", scriptId);

        googleAnalyticsScriptElement.onload = () => {
            initJostensGASY25Engine(requestData.customerNumber, requestData.publishedCatalogId, requestData.sourceCatalogType)
            pageLoadTrackingGASY25(requestData.catalogOsr)
            setInitialized(true)
        };
        googleAnalyticsScriptElement.onerror = (error) => {
            console.error('Failed to load GA tracking script:', error);
        };

        document.head.appendChild(googleAnalyticsScriptElement);
    }, [requestData?.customerNumber, requestData?.publishedCatalogId, requestData?.sourceCatalogType, requestData?.catalogOsr]);

    function initJostensGASY25Engine(customerNumber, publishedCatalogId, sourceCatalogType) {
        if (typeof window.jostensGaTracking !== "undefined") {
            window.jostensGaTracking.init({
                customerId: customerNumber,
                gaPageType: window.jostensGaTracking.gaPageTypeList.productListingPage,
                publishedCatalogId,
                publishedProductId: '-',
                sourceCatalogType
            })
        }
    }

    function pageLoadTrackingGASY25(catalogOsr) {
        if (typeof window.jostensGaTracking !== "undefined") {
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.productListingPage.productListingPageLoad,
                client: {
                    _resolveFields: {
                        businessUnit: { catalogOsr },
                        productLine: { catalogOsr }
                    }
                }
            })
        }
    }

    function selectItemTrackingGASY25(catalogOsr, clickText, modalType, itemName, actionType, 
            categoryName, contentName, contentType) {
        if (typeof window.jostensGaTracking !== "undefined") {
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.productListingPage.selectItem,
                client: {
                    _resolveFields: {
                        businessUnit: { catalogOsr },
                        productLine: { catalogOsr }
                    },
                    clickText, modalType, itemName, actionType, categoryName, contentName, contentType
                }
            })
        }
    }

    function viewModalTrackingGASY25(catalogOsr, modalType, itemName) {
        if (typeof window.jostensGaTracking !== "undefined") {
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.productListingPage.viewModal,
                client: {
                    _resolveFields: {
                        businessUnit: { catalogOsr },
                        productLine: { catalogOsr }
                    },
                    modalType, itemName
                }
            })
        }
    }

    function addToCartTrackingGASY25(catalogOsr, item, modalType, actionType, categoryName, currency, value) {
        if (typeof window.jostensGaTracking !== "undefined") {
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.productListingPage.addToCart,
                client: {
                    _resolveFields: {
                        businessUnit: { catalogOsr },
                        productLine: { catalogOsr }
                    },
                    modalType, actionType, categoryName,
                    order: {
                        items: [ item ]
                    },
                    currency,
                    value
                }
            })
        }
    }

    return (initialized) ? ({
        selectItemTrackingGASY25,
        viewModalTrackingGASY25,
        addToCartTrackingGASY25,
        catalogOSR: requestData?.catalogOsr
    }) : null
}